import type { MailboxInbox } from '@core/mailbox-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';

const { actions, reducer, namespace, selectors } =
  createEntityCollectionStore<MailboxInbox>()('mailbox-inboxes');

export {
  actions as MailboxInboxesActions,
  reducer as MailboxInboxesReducer,
  namespace as MailboxInboxesNamespace,
  selectors as MailboxInboxesSelectors,
};
